import React, { useEffect, useState } from 'react'
import { CButton, CCol } from '@coreui/react'
import { cilBuilding } from '@coreui/icons'
import DashboardFacility from './DashboardFacility'
import AddFacility from './AddFacility'
import './dashboard.css'

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [navVisible, setNavVisible] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setNavVisible(true);
  };

  useEffect(() => {
    if (activeTab === 'all' || activeTab === 'patient') {
      setNavVisible(false);
    }
  }, [activeTab]);
  // const renderTabContentByName = (tabName) => {
 

  //     switch (tabName) {
  //   case 'snf':
  //     return <div>snf Content</div>;
  //   case 'alf':
  //     return <div>alf Content</div>;
  //   case 'hospital':
  //     return <div>Hospital Content</div>;
  //   default:
  //     return 'snf';
  // }
  // };

  const renderTabContentByName = (tabName) => {
  switch (tabName) {
    case 'all':
      return <DashboardFacility />

    case 'snf':
      return <DashboardFacility type="SNF" />

    case 'alf':
      return <DashboardFacility type="ALF" />

    case 'hospital':
      return <DashboardFacility type="Hospital" />

    case 'mapView':
      return <AddFacility dashboardMapView />

    default:
      return <DashboardFacility />
  }
}

  const tabIcons = {
 'all': cilBuilding,
  'snf': cilBuilding,
  'alf': cilBuilding,
  'hospital': cilBuilding,
  'mapView': cilBuilding,
  };

  const tabLabels = {
    all: 'ALL',
    snf: 'SNF',
    alf: 'ALF',
    hospital: 'HOSPITAL',
    mapView: 'Map View',
  }

  

 



return (
  <div className="dashboard-dark-theme dashboard-dark-shell">
<div className="d-flex gap-3 mb-3 justify-content-center flex-wrap dashboard-dark-tabs">
  {Object.keys(tabIcons).map((tabName) => {
    const isActive = activeTab === tabName;

    return (
      <CCol sm={1} key={tabName}>
        <CButton
          className={`dashboard-dark-tab ${isActive ? 'dashboard-dark-tab--active' : ''}`}
          onClick={() => handleTabClick(tabName)}
        >
          <div className="d-flex align-items-center gap-2 py-2 px-2 justify-content-center dashboard-dark-tab__inner">
            <h6 className="m-0 dashboard-dark-tab__label">
              {tabLabels[tabName] || tabName.toUpperCase()}
            </h6>
          </div>
        </CButton>
      </CCol>
    );
  })}
</div>
        <div>
        {renderTabContentByName(activeTab)}
      </div> 
  </div>
)
}

export default Dashboard
